export enum InsuranceProvider {
  Medicare = 'Medicare',
  TexasMedicaid = 'Texas Medicaid',
  PrivatePay = 'Private Pay',
  TexasMedicaidHMO = 'Texas Medicaid HMO',
  Commercial = 'Commercial',
  CaliforniaMedicaid = 'California Medicaid',
}
